import {Component, Injector, ViewChild} from '@angular/core';
import {BaseComponent} from "../../base/base.component";
import {ProductSize} from "../../../models/shop/ProductSize";
import {NgxSmartModalService} from "ngx-smart-modal";
import {ShopService} from "../../../services/shop/shop.service";
import {ActivatedRoute} from "@angular/router";
import {ProductColor} from "../../../models/shop/productColor";
import {TableComponent} from "../../ui/table/table.component";
import {Product} from "../../../models/shop/product";
import Swal from "sweetalert2";

@Component({
  selector: 'app-shop-color',
  templateUrl: './color.component.html',
  styleUrls: ['./color.component.scss']
})
export class ColorComponent extends BaseComponent {

  @ViewChild('colorList') colorList: TableComponent | undefined;
  companyId: string = localStorage.getItem('wisper_companyId') ?? '';

  constructor(public serviceInjector: Injector,
              private modal: NgxSmartModalService,
              public shopService: ShopService) {
    super(serviceInjector);
  }

  async ngAfterViewInit() {
    this.showSpinner();
    this.colorList?.loadData(`/productColors`, {companyId: this.companyId}, ( (item: any) => new ProductColor(item)))
    this.hideSpinner();
  }


  showEditColorModal(productToEdit: Product) {
    this.modal.getModal('editColorModal').setData(productToEdit);
    this.modal.getModal('editColorModal').open();
  }

  showAddColorModal() {
    let newProduct = new Product();
    this.modal.setModalData(newProduct, 'addColorModal');
    this.modal.getModal('addColorModal').open();
  }

  async addColor(productToAdd: Product) {
    this.spinner.show();

    productToAdd['companyId'] = this.companyId
    let response = await this.shopService.addColor(productToAdd);
    this.spinner.hide();

    if (response.success){
      Swal.fire({
        icon: 'success',
        title: 'Colore creato con successo'
      });
      //refresh
      this.colorList?.reloadPage();
      this.modal.getModal('addColorModal').close();
    } else {
      Swal.fire({
        icon: 'error',
        title: "Errore durante la creazione del colore"
      });
    }
  }

  async editColor(sizeToAdd: ProductSize) {
    this.spinner.show();

    console.log(this.companyId)
    sizeToAdd['companyId'] = this.companyId
    let response = await this.shopService.editColor(sizeToAdd.id ?? '', sizeToAdd);

    if (response.success) {
      this.spinner.hide();
      Swal.fire({
        icon: 'success',
        title: 'Colore modificato con successo'
      });
      //refresh
      this.colorList?.reloadPage();
      this.modal.getModal('editColorModal').close();
    } else {
      this.spinner.hide();
      Swal.fire({
        icon: 'error',
        title: "Errore, riprova a modificare il colore"
      });
    }
  }

  deleteColor = async (colorId: string) => {
    const success = await this.shopService.deleteColor(colorId)
    if (success) {
      Swal.fire({
        icon: 'success',
        title: 'Colore eliminato con successo!',
      });
      //refresh
      this.colorList?.reloadPage();
    } else {
      Swal.fire({
        icon: 'error',
        title: "Errore nell'eliminazione del colore",
      })
    }
  }

}
